import { SortSymbols } from '@webitel/ui-sdk/src/scripts/sortQueryAdapters';

export default [
  {
    value: 'name',
    locale: ['objects.ccenter.res.numbers', 2],
    field: 'display',
    sort: SortSymbols.NONE,
  },
];
